const coupon = {
  message: 'The coupon code has been saved and will be applied after adding the product to the shopping cart.',
  toProduct: 'To the product',
  toProducts: 'To the products',
  coupon: 'Coupon',
}

export default coupon
